import store from '../store';

import { loginSuccess, loginFail } from '../store/actions/loginAction';
import { userSuccess } from '../store/actions/userAction';

import axios from 'axios';
import { headers } from '../api/headers';
import { baseUrl } from '../api/baseUrl';

import User from '../models/User';
import { openTermsModal } from '../store/actions/termsAndConditionsModalAction';

function handleLogin(callback?: Function): void {

  axios({
    method: 'get',
    url: baseUrl + 'whoami',
    headers: headers,
    withCredentials: true
  }).then(res => {

    const user: User | undefined = res.data.result;
    
    if (user) {
      if(!user.terms_and_conditions_agreed) {
        store.dispatch(openTermsModal());
      }
      store.dispatch(userSuccess(user));
      store.dispatch(loginSuccess());
      if(callback)
        callback();
    }

  }).catch(error => {
    store.dispatch(loginFail());
  });
}

function isPasswordSecure(password: string) {
  let atLeast8CharPassword = password.length >= 8;
  let atLeast1Number = false, atLeastOneSymbol = false, atLeastOneUpperCase = false;

  for (let i = 0; i < password.length; i++) {
    let c = password[i];
    if (c >= '0' && c <= '9')
      atLeast1Number = true;
    if (c >= 'A' && c <= 'Z')
      atLeastOneUpperCase = true;

    let specialChars: string = "!@#_";
    if (specialChars.indexOf(c) != -1)
      atLeastOneSymbol = true;
  }

  let allTypesCharsPassword = atLeast1Number && atLeastOneSymbol && atLeastOneUpperCase;

  return {valid: atLeast8CharPassword && allTypesCharsPassword, allTypesCharsPassword, atLeast8CharPassword};
}

export {
  handleLogin, isPasswordSecure
}